import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router';
import { Context as AuthContext } from '../../providers/AuthProvider';

const PrivateRoute = ({ children, ...rest }) => {
  const { state } = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        state.isSignedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = { children: PropTypes.any };

export default PrivateRoute;
